import React from "react";
import { FormView } from "./view";
import { styles } from "./styles";

export const Form = props => <FormView {...props} styles={styles} />;
